import { Method } from 'axios';
import { Executable } from '../executable';

/**
 * The attributes defined for the provided brand.
 */
export class DeleteBrandAttribute extends Executable<boolean> {
  public brandId: number;

  public brandAttributeId: number;

  public getMethod(): Method {
    return 'delete';
  }

  public getResponse(apiResponse: any): boolean {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.brandAttributeId) throw new Error('brandAttributeId is required');
    return `/${this.brandId}/attributes/${this.brandAttributeId}`;
  }

  constructor(brandId: number, brandAttributeId: number) {
    super();
    this.brandId = brandId;
    this.brandAttributeId = brandAttributeId;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
